"use client";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";

export default function SaleSummary({
  subtotal = 0,
  tax = 0,
  total = 0,
  onPaymentMethodChange,
  onSave,
  onPrint,
  isLoading = false,
  hidePaymentMethod = false, // Allow parent to handle payment method separately
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Sale Summary</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex justify-between">
          <span>Subtotal:</span>
          <span>${(subtotal || 0).toFixed(2)}</span>
        </div>
        <div className="flex justify-between">
          <span>Tax (10%):</span>
          <span>${(tax || 0).toFixed(2)}</span>
        </div>
        <div className="flex justify-between font-bold">
          <span>Total:</span>
          <span>${(total || 0).toFixed(2)}</span>
        </div>
        {!hidePaymentMethod && (
          <div className="space-y-2">
            <Label>Payment Method</Label>
            <Select
              onValueChange={(value) => {
                if (onPaymentMethodChange) {
                  onPaymentMethodChange(value);
                }
              }}
              defaultValue="cash"
            >
              <SelectTrigger>
                <SelectValue placeholder="Select payment method" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="cash">Cash</SelectItem>
                <SelectItem value="card">Card</SelectItem>
                <SelectItem value="mobile">Mobile Payment</SelectItem>
              </SelectContent>
            </Select>
          </div>
        )}
      </CardContent>
      <CardFooter className="flex flex-col gap-4">
        <Button
          className="w-full"
          onClick={onSave}
          disabled={isLoading || !onSave || total <= 0}
        >
          {isLoading ? "Processing..." : "Complete Sale"}
        </Button>
        <Button
          variant="outline"
          className="w-full"
          onClick={onPrint}
          disabled={isLoading || !onPrint || total <= 0}
        >
          Print Receipt
        </Button>
      </CardFooter>
    </Card>
  );
}

